// src/services/api.js
import axios from 'axios';
import { supabase } from './supabaseClient';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_PRISMA_API_URL}/api`,
});

// Interceptor para adjuntar el token JWT de Supabase a todas las peticiones
api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token) {
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }
  return config;
});

export default api;
